import 'angular';
import './file_browser_file_selected_right_menu.html';
import './file_browser_folder_selected_right_menu.html';
import './file_browser_multi_selected_right_menu.html';

angular.module('GorillaBoy.directives')
.directive('fileSelectedList', ['$log', ($log) => {
    return {
        replace: true,
        templateUrl: './file-browser/right_click_menus/file_browser_file_selected_right_menu.html'
    };
}])
.directive('folderSelectedList', ['$log', ($log) => {
    return {
        replace: true,
        templateUrl: './file-browser/right_click_menus/file_browser_folder_selected_right_menu.html'
    };
}])
.directive('multiSelectedList', ['$log', ($log) => {
    return {
        replace: true,
        templateUrl: './file-browser/right_click_menus/file_browser_multi_selected_right_menu.html'
    };
}])